export const CONSENT_STORAGE_KEY = 'vn_cookie_consent_v1';
export const CONSENT_VERSION = 1;

export const defaultCookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export function normalizeCookiePreferences(preferences = {}) {
  return {
    necessary: true,
    analytics: Boolean(preferences.analytics),
    marketing: Boolean(preferences.marketing),
  };
}

export function readStoredConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== CONSENT_VERSION) return null;
    return {
      ...parsed,
      preferences: normalizeCookiePreferences(parsed.preferences || {}),
    };
  } catch {
    return null;
  }
}

export function buildConsentPayload(preferences) {
  return {
    version: CONSENT_VERSION,
    accepted_at: new Date().toISOString(),
    preferences: normalizeCookiePreferences(preferences),
  };
}
